import React from 'react';
import ReportingFinancesSalesTaxPage from '../components/ReportingFinancesSalesTaxPage';

const ReportingFinancesSalesTaxApp = (props) => (
  <ReportingFinancesSalesTaxPage {...props} />
);

export default ReportingFinancesSalesTaxApp;
